import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import { ChiTietHopDongResponse, HopDongRequest, HopDongResponse, HopDongHetHan, LayTienTheoPhuCapResponse, BacLuongResponse, PhuCapResponse, QDBLRequest, HopDongDienTu, LuuHopDongDienTuRequest, ChiTietHopDongDienTuResponse, PheDuyetHopDongDienTuRequest } from "../models/hopdong/HopDong";
import { TimKiemNhanVienHopDongRequest } from "../models/nhanvien/NhanVien";
import intance from "../utils/axios";



/// Tạo tệp hợp đồng điện tử từ tệp mẫu đang cấu hình, trả về response dạng blob (.docx)
export const taoHopDongDienTu = async (request: HopDongDienTu) => {
    var rs: any;
    await intance.post(ApiPaths.hopDong.taoHopDongDienTu, request, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch(async (err) => {
            let thongBao = 'Có lỗi xảy ra. Vui lòng thử lại';
            const duLieuLoi = err?.response?.data;
            if (duLieuLoi instanceof Blob) {
                try {
                    const json = JSON.parse(await duLieuLoi.text());
                    thongBao = json?.thongBao || thongBao;
                } catch (e) {
                }
            }
            throw new Error(thongBao);
        });
    return rs;
};

/// Lấy bản PDF của hợp đồng điện tử, trả về response dạng blob
export const xemPdfHopDongDienTu = async (id: number) => {
    var rs: any;
    await intance.get(ApiPaths.hopDong.xemPdfHopDongDienTu + "?id=" + id, { responseType: 'blob' })
        .then((res) => {
            rs = res;
        })
        .catch(async (err) => {
            let thongBao = 'Có lỗi xảy ra. Vui lòng thử lại';
            const duLieuLoi = err?.response?.data;
            if (duLieuLoi instanceof Blob) {
                try {
                    const json = JSON.parse(await duLieuLoi.text());
                    thongBao = json?.thongBao || thongBao;
                } catch (e) {
                }
            }
            throw new Error(thongBao);
        });
    return rs;
};

/// Lấy chi tiết hợp đồng điện tử theo id
export const layChiTietHopDongDienTu = async (id: number) => {
    var rs: ChiTietHopDongDienTuResponse = new ChiTietHopDongDienTuResponse;
    await intance.get(ApiPaths.hopDong.layChiTietHopDongDienTu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

/// Lưu hợp đồng điện tử, trả về id bản ghi vừa lưu
export const luuHopDongDienTu = async (request: LuuHopDongDienTuRequest) => {
    var id = 0;
    const formData = new FormData();
    formData.append("id", (request.id || "").toString());
    formData.append("idNhanVien", request.idNhanVien?.toString() || "0");
    formData.append("idHopDongCu", request.idHopDongCu?.toString() || "0");
    formData.append("idNVKyNhay", request.idNVKyNhay?.toString() || "0");
    formData.append("idLoaiHopDong", request.idLoaiHopDong?.toString() || "0");
    formData.append("idChucVu", request.idChucVu?.toString() || "0");
    formData.append("soHopDong", request.soHopDong || "");
    formData.append("ngayBatDau", request.ngayBatDau || "");
    formData.append("ngayKetThuc", request.ngayKetThuc || "");
    formData.append("ngayKy", request.ngayKy || "");
    formData.append("thoiGianLamViec", request.thoiGianLamViec || "");
    formData.append("diaDiemLamViec", request.diaDiemLamViec || "");
    formData.append("nguonFile", request.nguonFile?.toString() || "");
    formData.append("isTrinh", (!!request.isTrinh).toString());
    formData.append("lyDo", request.lyDo || "");
    if (request.file) {
        formData.append("file", request.file);
    }

    await intance.post(ApiPaths.hopDong.luuHopDongDienTu, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                id = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return id;
};

/// Người ký nháy phê duyệt hoặc trả lại hợp đồng điện tử
export const pheDuyetHopDongDienTu = async (request: PheDuyetHopDongDienTuRequest) => {
    await intance.post(ApiPaths.hopDong.pheDuyetHopDongDienTu, request)
        .then((res) => {
            if (res.data.trangThai !== responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

/// Lấy số hợp đồng điện tử để đóng lên tệp ký số, hợp đồng chưa có số thì hệ thống cấp số mới
export const laySoHopDongDienTu = async (id: number) => {
    var soHopDong = '';
    await intance.post(ApiPaths.hopDong.laySoHopDongDienTu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                soHopDong = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return soHopDong;
};

export const layDsHopDongTheoIdNhanVien = async (idNhanVien: number) => {
    var rs: HopDongResponse = new HopDongResponse;
    await intance.get(ApiPaths.hopDong.layDsTheoIdNhanVien + "?idNhanVien=" + idNhanVien)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const timKiemDSNhanVienHopDong = async (request: TimKiemNhanVienHopDongRequest, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.hopDong.timKiemDSNhanVienHopDong, {
        "start": start,
        "length": length,
        "filter": {
            "idDonVi": request.idDonVi,
            "tuKhoa": request.tuKhoa || "",
            "idLoaiHopDong": request.idLoaiHopDong
        },
        "orderBy": {
            "columnName": "ten",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};


/// Tìm kiếm danh sách hợp đồng điện tử, truyền length = 0 để lấy toàn bộ và phân trang phía client
export const timKiemDSHopDongDienTu = async (request: TimKiemNhanVienHopDongRequest, start: number, length: number) => {
    var data = {
        data: [] as Array<ChiTietHopDongDienTuResponse>,
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.hopDong.timKiemDSHopDongDienTu, {
        "start": start,
        "length": length,
        "filter": {
            "idDonVi": request.idDonVi,
            "tuKhoa": request.tuKhoa || "",
            "idLoaiHopDong": request.idLoaiHopDong
        },
        "orderBy": {
            "columnName": "ngayBatDau",
            "isDesc": true
        }
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layCTHopDong = async (id: number) => {
    var rs: ChiTietHopDongResponse = new ChiTietHopDongResponse;
    await intance.get(ApiPaths.hopDong.layCT + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const luuQuyetDinhBacLuong = async (request: QDBLRequest) => {    
    const formData = new FormData();
    formData.append("id", (!!request.id ? request.id : "").toString());
    formData.append("idChucVu", request.idChucVu?.toString() || "0");
    formData.append("idDonVi", request.idDonVi?.toString() || "0");
    formData.append("idHeSoLuong", request.idHeSoLuong?.toString() || "0");
    formData.append("idHopDong", request.idHopDong?.toString() || "0");
    formData.append("idNhomNhanSu", request.idNhomNhanSu?.toString() || "0");
    formData.append("ngayBatDau", request.ngayBatDau?.toString() || "");
    formData.append("ngayKetThuc", request.ngayKetThuc?.toString() || "");
    formData.append("ngayKyQD", request.ngayKyQD?.toString() || "");
    formData.append("soQD", request.soQD?.toString() || "");
    formData.append("mucLuongThucNhan", request.mucLuongThucNhan?.toString() || "");
    request.files.forEach((file, index) => {
        formData.append("files", file);
    })
    request.idsTaiLieuQDBLXoa.forEach((item, index) => {
        formData.append("idsTaiLieuQDBLXoa", item.toString());
    })
    await intance.post(ApiPaths.hopDong.luuQDBacLuong, formData, {
        headers: {
            "Content-Type": "multipart/form-data"
        },
    })
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaQuyetDinhBacLuong = async (id: number) => {
    await intance.get(ApiPaths.hopDong.xoaQDBacLuong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuPhuCapNhanSu = async (data: any) => {
    await intance.post(ApiPaths.hopDong.luuPhuCapNhanSu, data)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const xoaPhuCapNhanSu = async (id: number) => {
    await intance.get(ApiPaths.hopDong.xoaPhuCapNhanSu + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const luuHopDong = async (request: HopDongRequest) => {
    var response = { trangThai: responseStatus.loi };
    const formData = new FormData();
    formData.append("id", (!!request.id ? request.id : "").toString());
    formData.append("tenNguoiKy", request.tenNguoiKy?.toString() || "");
    formData.append("idNhanVien", request.idNhanVien?.toString() || "");
    formData.append("idLoaiHopDong", request.idLoaiHopDong?.toString() || "");
    formData.append("soHopDong", request.soHopDong?.toString() || "");
    formData.append("ngayBatDau", request.ngayBatDau?.toString() || "");
    formData.append("ngayKetThuc", request.ngayKetThuc?.toString() || "");
    formData.append("ngayKy", request.ngayKy?.toString() || "");
    formData.append("trangThai", request.trangThai?.toString() || "0");
    formData.append("idHopDongDienTu", request.idHopDongDienTu?.toString() || "0");
    formData.append("noiDung", request.noiDung || "");
    formData.append("isDongBHXH", request.isDongBHXH?.toString() || "false");
    formData.append("noiKy", request.noiKy || "");
    formData.append("idQDBLCu", request.idQDBLCu?.toString() || "");
    request.files.forEach((file, index) => {
        formData.append("files", file);
    })
    request.idsTaiLieuHopDongXoa.forEach((item, index) => {
        formData.append("idsTaiLieuHopDongXoa", item.toString());
    })

    await intance.post(ApiPaths.hopDong.luuHopDong, formData,
        {
            headers: {
                "Content-Type": "multipart/form-data"
            },
        })
        .then(res => {
            response = res.data;
        })
        .catch(err => {
        });
    return response;
};

export const xoaHopDong = async (id: number) => {
    await intance.get(ApiPaths.hopDong.xoaHopDong + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {

            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
};

export const layHopDongHetHan = async () => {
    var rs: Array<HopDongHetHan> = [];
    await intance.get(ApiPaths.hopDong.layHopDongHetHan)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs; 
}

export const layTienPhuCap = async (idDonVi: number, idChucVu: number, idPhuCap: number) => {
    var rs: LayTienTheoPhuCapResponse = new LayTienTheoPhuCapResponse;
    await intance.get(ApiPaths.hopDong.layTienPhuCap + `?idDonVi=${idDonVi}&idChucVu=${idChucVu}&idPhuCap=${idPhuCap}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};

export const layDanhSachPhuCapTheoHDvaQDBL = async (idHopDong: number, idQDBL: number) => {
    var rs: Array<PhuCapResponse> = [];

    await intance.get(ApiPaths.hopDong.layDSPhuCapTheoHDvaQDBL + `?idHopDong=${idHopDong}&idQDBL=${idQDBL}`)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}

export const layDsQDBLTheoIdNhanVien = async (idNhanVien: number) => {
    var rs: Array<BacLuongResponse> = [];
    await intance.get(ApiPaths.hopDong.layDsQDBLTheoIdNhanVien + "?idNhanVien=" + idNhanVien)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
};
